import { OptArr } from '@/types/kyc'

export const familyStatus: OptArr = [{
  value: 'MarriedChildren',
  label: '已婚有子女'
}, {
  value: 'MarriedNoChildren',
  label: '已婚无子女'
}, {
  value: 'SingleChildren',
  label: '单身有子女'
}, {
  value: 'SingleNoChildren',
  label: '单身无子女'
}]

export const libilityListStatus: OptArr = [{
  value: 'Conservative',
  label: 'R1-保守型'
}, {
  value: 'ConservativeModerately',
  label: 'R2-相对保守型'
}, {
  value: 'Steady',
  label: 'R3-稳健型'
}, {
  value: 'PositiveModerately',
  label: 'R4-相对积极型'
}, {
  value: 'Positive',
  label: 'R5-积极型'
}]
